import * as Yup from 'yup';

// Esquema de validación para la tabla traslado
export const trasladoValidationSchema = Yup.object().shape({
    // Define aquí los campos requeridos para la tabla traslado
    
    fecha: Yup.date()
        .required('La fecha es obligatoria')
        .typeError('Debe ser una fecha válida'),    
   
});

export const validateTrasladoForm = async (formData) => {
    try {
        await trasladoValidationSchema.validate(formData, { abortEarly: false });
        return {}; // No hay errores
    } catch (error) {
        const errors = {};
        if (error.inner) {
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
        }
        return errors; // Devuelve los errores de validación
    }
};
